const BROWSER_NATIVE_EXTENSIONS = new Set(['.mp4', '.webm']);

/**
 * For imgix-hosted videos with non-browser-native extensions (e.g. .mov, .avi),
 * append `fm=mp4` so imgix transcodes the video to a playable format.
 * Returns the URL unchanged for non-imgix sources or already-native formats.
 */
export const getImgixVideoPlaybackUrl = (src: string): string => {
  try {
    const url = new URL(src);

    if (!url.hostname.endsWith('.imgix.net')) {
      return src;
    }

    if (url.searchParams.has('s')) {
      return src;
    }

    const dotIndex = url.pathname.lastIndexOf('.');

    if (dotIndex === -1) {
      return src;
    }
    const ext = url.pathname.substring(dotIndex).toLowerCase();

    if (BROWSER_NATIVE_EXTENSIONS.has(ext)) {
      return src;
    }

    url.searchParams.set('fm', 'mp4');

    return url.toString();
  } catch {
    return src;
  }
};
